import { padZero } from "./String";

/**
 * Takes a string, hashes it to return a HEX color.
 *
 * For example, when passed "foo" it returns "#c68c01"
 *
 * If string is undefined then it returns #ffffff
 *
 * @source https://stackoverflow.com/a/16348977/1349766
 * @export
 * @param {string} str
 * @returns
 */
export function stringToColour(str: string): string {

    if (!str) {
        return "#ffffff";
    }

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let colour = "#";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
    }
    return colour;
}

/**
 * Inverts a HEX color.
 *
 * Provides a color that is on the opposite side of the color wheel.
 *
 * When passed true as the second parameter, it will invert the color
 * and provide it within grey scale to help with contrast and readability.
 *
 * @source https://stackoverflow.com/a/35970186
 * @export
 * @param {string} hex
 * @param {boolean} [bw]
 * @returns
 */
export function invertColor(hex: string, bw?: boolean): string {
    if (!hex) {
        return undefined;
    }

    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error("Invalid HEX color.");
    }
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    }
    // pad each with zeros and return
    return "#" + padZero((255 - r).toString(16)) + padZero((255 - g).toString(16)) + padZero((255 - b).toString(16));
}
